// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ocBG","rootMobile":"styles_rootMobile__1xYLw"};